module.exports = __webpack_public_path__ + "img/SL-M-240-300.4fefa50f.svg";